import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class ArenaHistoryView extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, callback: () => void) {
        super(scene, canvas, Tr('istorija.areni'));

        SpriteUtils.scale(this, 1.2 / CU.S);

        this.setOnCLoseCallback(callback);
    }
}